import React from "react";
import { Grid } from "@mui/material";

import Input from "../ReadOnlyInput";
import InputCheckbox from "../ReadOnlyCheckbox";
import {
  formatCPF,
  formatPhoneWithDdd,
  timeStampToDate,
  formatUpperCase,
  formatCNPJ,
  formatMonetary,
} from "../../../../utils/formats";
import { Separator } from "../styles";
import { map, toUpper } from "lodash";

const InformacoesEmpresariaisSection = (props) => {
  const {
    proposalCompleteRegistrationLoading,
    proposalPartnershipRegistrations,
    proposalPartnershipRegistrationsLoading,
    numeroCpf,
    nomeCliente,
    dataNascimentoCliente,
    idadeCliente,
    descricaoSexo,
    nacionalidade,
    naturalidade,
    ufNaturalidade,
    dataCadastro,
    dataValidadeCadastro,
    descricaoTipoDocumento,
    numeroDocumento,
    dataExpedicaoDocumento,
    siglaOrgaoEmissor,
    nomePai,
    nomeMae,
    dddTelefone,
    telefone,
    dddCelular,
    celular,
    email,
    descricaoGrauInstrucao,
    numeroDependentes,
    isAnalfabeto,
    isEmancipado,
    descricaoEstadoCivil,
    isUniaoEstavel,
    tipoPessoa,
    numeroCnpj,
    razaoSocial,
    nomeFantasia,
    dataFundacao,
    inscricaoEstadual,
    inscricaoMunicipal,
    codigoRamoAtividade,
    descricaoRamoAtividade,
    porteEmpresa,
    codigoCnae,
    descricaoCnae,
    faturamentoAnual,
  } = props;

  return (
    <>
      {toUpper(tipoPessoa) === "F" ? (
        <>
          <Grid container spacing={3}>
            <Grid item md={4}>
              <Input
                label="CPF"
                value={formatCPF(numeroCpf)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={8}>
              <Input
                label="Nome"
                value={nomeCliente}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>

            <Grid item md={4}>
              <Input
                label="Data de nascimento"
                value={timeStampToDate(dataNascimentoCliente)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={4}>
              <Input
                label="Idade"
                value={idadeCliente ? `${idadeCliente} ANOS` : ""}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={4}>
              <Input
                label="Sexo"
                value={formatUpperCase(descricaoSexo)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={4}>
              <Input
                label="Nacionalidade"
                value={formatUpperCase(nacionalidade)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={4}>
              <Input
                label="Naturalidade"
                value={formatUpperCase(naturalidade)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={4}>
              <Input
                label="UF naturalidade"
                value={ufNaturalidade}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={4}>
              <Input
                label="Data do cadastro"
                value={timeStampToDate(dataCadastro)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={4}>
              <Input
                label="Validade do cadastro"
                value={timeStampToDate(dataValidadeCadastro)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
          </Grid>

          <Separator />

          <Grid container spacing={3}>
            <Grid item md={3}>
              <Input
                label="Tipo de documento"
                value={formatUpperCase(descricaoTipoDocumento)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                label="Número do documento"
                value={numeroDocumento}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                label="Data da emissão"
                value={timeStampToDate(dataExpedicaoDocumento)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={3}>
              <Input
                label="Orgão emissor"
                value={siglaOrgaoEmissor}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={12}>
              <Input
                label="Nome do pai"
                value={formatUpperCase(nomePai)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={12}>
              <Input
                label="Nome da mãe"
                value={formatUpperCase(nomeMae)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={4}>
              <Input
                label="Telefone"
                value={formatPhoneWithDdd(dddTelefone, telefone)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={4}>
              <Input
                label="Celular"
                value={formatPhoneWithDdd(dddCelular, celular)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={4}>
              <Input
                label="E-mail"
                value={formatUpperCase(email)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={4}>
              <Input
                label="Grau de instrução"
                value={formatUpperCase(descricaoGrauInstrucao)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={4}>
              <Input
                label="Número de dependentes"
                value={numeroDependentes}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={2} alignSelf="flex-end">
              <InputCheckbox
                label="Analfabeto"
                checked={isAnalfabeto}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={2} alignSelf="flex-end">
              <InputCheckbox
                label="Emancipado"
                checked={isEmancipado}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={4}>
              <Input
                label="Estado civil"
                value={formatUpperCase(descricaoEstadoCivil)}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
            <Grid item md={3} alignSelf="flex-end">
              <InputCheckbox
                label="União estavel"
                checked={isUniaoEstavel}
                loading={proposalCompleteRegistrationLoading}
              />
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Grid container spacing={3}>
            <Grid item xs={2}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="CNPJ"
                value={formatCNPJ(numeroCnpj)}
              />
            </Grid>
            <Grid item xs={5}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Razão social"
                value={formatUpperCase(razaoSocial)}
              />
            </Grid>
            <Grid item xs={5}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Nome fantasia"
                value={formatUpperCase(nomeFantasia)}
              />
            </Grid>
            <Grid item xs={2}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Fundação"
                value={timeStampToDate(dataFundacao)}
              />
            </Grid>
            <Grid item xs={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Inscrição Estadual"
                value={inscricaoEstadual}
              />
            </Grid>
            <Grid item xs={3}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Inscrição Municipal"
                value={inscricaoMunicipal}
              />
            </Grid>
            <Grid item xs={2}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Porte Empresa"
                value={formatUpperCase(porteEmpresa)}
              />
            </Grid>
            <Grid item xs={2}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Faturamento Anual"
                value={formatMonetary(faturamentoAnual)}
              />
            </Grid>
            <Grid item xs={6}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="Ramo de Atividade"
                value={`${codigoRamoAtividade ?? ""} - ${
                  descricaoRamoAtividade ?? ""
                }`}
              />
            </Grid>
            <Grid item xs={6}>
              <Input
                loading={proposalCompleteRegistrationLoading}
                label="CNAE"
                value={`${codigoCnae ?? ""} - ${descricaoCnae ?? ""}`}
              />
            </Grid>
          </Grid>

          <Separator />

          <Grid container spacing={1}>
            {map(
              proposalPartnershipRegistrationsLoading
                ? [{}]
                : proposalPartnershipRegistrations,
              (partner, index) => {
                const isPF = toUpper(partner.tipoSocio) === "F";
                return (
                  <>
                    <Grid item xs={6} key={"nome" + index}>
                      <Input
                        loading={proposalPartnershipRegistrationsLoading}
                        label={index === 0 ? "Sócio" : ""}
                        value={formatUpperCase(partner.nomeSocio)}
                      />
                    </Grid>
                    <Grid item xs={3} key={"cpfCnpj" + index}>
                      <Input
                        loading={proposalPartnershipRegistrationsLoading}
                        label={index === 0 ? "CPF / CNPJ" : ""}
                        value={
                          isPF
                            ? formatCPF(partner.cpfCnpj)
                            : formatCNPJ(partner.cpfCnpj)
                        }
                      />
                    </Grid>
                    <Grid item xs={3} key={"coopart" + index}>
                      <Input
                        loading={proposalPartnershipRegistrationsLoading}
                        label={index === 0 ? "Participação" : ""}
                        value={
                          partner.porcentagemParticipacao
                            ? partner.porcentagemParticipacao + "%"
                            : "0%"
                        }
                      />
                    </Grid>
                  </>
                );
              }
            )}
          </Grid>
        </>
      )}
    </>
  );
};

export default InformacoesEmpresariaisSection;
